<template>
  <footer class="fs-the-footer">
    <div
      id="footer-link"
      class="bg-gray-700 flex justify-center items-center flex-col border-t-4 border-primary-600 py-8 md:flex-row md:px-8"
    >
      <div class="flex justify-center items-center flex-col m-3">
        <img :src="isMobile" alt="logo" class="mx-auto" />
        <div class="flex justify-center items-center">
          <a
            v-for="(info, index) in iconLinks"
            :key="index"
            aria-label="icon"
            rel="noopenner noreferrer"
            :href="info.href"
            :target="info.target"
            class="cursor-pointer"
            @click.prevent="handleOpenLinkAlert(info)"
          >
            <div
              class="bg-gray-100 text-gray-600 w-8 h-8 flex justify-center items-center rounded-full mt-4 mx-2"
            >
              <img
                :src="require(`@/assets/images/${info.iconClass}.svg`)"
                alt=""
                :class="[
                  info.iconClass === 'line' ? 'w-6 h-6' : 'w-[22px] h-[22px]',
                ]"
              />
            </div>
          </a>
        </div>
        <a
          class="w-36 text-white text-center text-sm font-bold p-2 mt-4 rounded-lg cursor-pointer hover:text-white"
          style="background-color: #06c755"
          rel="noopenner noreferrer"
          href="https://lin.ee/zCMpQQe"
        >
          手機撥打 LINE 客服
        </a>
      </div>

      <div class="text-white text-center text-xs md:text-left">
        <div
          v-for="(message, index) in siteFooterMessages"
          :key="'msg' + index"
          class="leading-6 mt-2 px-2 md:mt-0"
        >
          {{ message }}
        </div>

        <div
          class="flex justify-center items-center flex-col-reverse md:flex-col md:items-start"
        >
          <div>
            <div
              v-for="(info, index) in links"
              :key="'info' + index"
              class="border-r border-white px-2 my-2 last:border-r-0 inline-block"
            >
              <a
                aria-label="icon"
                target="_self"
                rel="noopenner noreferrer"
                class="text-white cursor-pointer hover:text-primary-600"
                :href="info.href"
              >
                {{ info.title }}
              </a>
            </div>
          </div>

          <div
            class="border-b border-gray-100 w-4/5 my-3 md:border-b-0 md:m-0"
          ></div>

          <div>
            <div
              v-for="(message, index) in siteFooterMessages2"
              :key="'msg2' + index"
              class="px-2 leading-6 md:inline-block"
            >
              {{ message }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      :class="['bg-gray-600 text-white text-xs p-5 md:p-12']"
      @click="openSectionTwo"
    >
      <div id="msg" class="text-new-gray-500">
        <p
          v-for="(info, index) in footerMessagesSectionOne"
          :key="index"
          v-html="info"
        />
      </div>
      <div
        :class="[
          'relative overflow-hidden transition-all max-h-0 duration-150 2xl:max-h-screen',
        ]"
        :style="
          showSectionTwo && 'max-height: ' + $refs.ans.scrollHeight + 'px'
        "
        ref="ans"
      >
        <div class="text-new-gray-500">
          <p
            v-for="(info, index) in footerMessagesSectionTwo"
            :key="index"
            v-html="info"
          />
        </div>
      </div>
      <div
        :class="[
          'bg-gradient-to-t from-gray-600 to-backdrop-opacity-50 sticky bottom-0 w-full h-16 flex justify-center items-center text-primary-600 cursor-pointer -mt-12 2xl:hidden',
          showSectionTwo && 'mt-0',
        ]"
      >
        <div
          :class="[
            'absolute bottom-2',
            showSectionTwo ? 'animate-toggle-open' : 'animate-toggle-close',
          ]"
        >
          <img
            :src="require(`@/assets/images/chevron-down-solid.svg`)"
            alt=""
            class="w-4 h-4 text-new-primary-500"
          />
        </div>
      </div>
    </div>

    <alert-outside-link
      v-model="isShowAlert"
      ref="alertOutsideLink"
    ></alert-outside-link>
  </footer>
</template>

<script>
import AlertOutsideLink from "@/components/AlertOutsideLink.vue";
export default {
  name: "TheFooter",
  props: {
    apiBaseUrl: {
      type: String,
      default: () => "/trade/api",
    },
  },
  components: {
    AlertOutsideLink,
  },
  data() {
    return {
      showSectionTwo: false,
      siteFooterMessages: ["證券商許可執照：110 年金管證總字第 0038 號"],
      siteFooterMessages2: [
        "客服電話：+886 2 7755-7722",
        "營業地址：新北市板橋區中山路 1 段 156-1 號 2 樓之 1",
      ],
      footerMessages: null,
      isShowAlert: false,
    };
  },

  computed: {
    iconLinks() {
      return [
        {
          href: "https://www.facebook.com/FundSwapTW/",
          iconPack: "fab",
          iconClass: "facebook-f",
          target: "_self",
        },
        {
          href: "mailto:hello@fundswap.com.tw",
          iconPack: "fas",
          iconClass: "envelope-solid",
        },
        {
          href: "https://lin.ee/jhSTTO2",
          iconPack: "fab",
          iconClass: "line",
          target: "_self",
        },
      ];
    },

    links() {
      return [
        // {
        //   title: '會員條款',
        //   pathName: 'member-terms'
        // },
        {
          title: "個人資料保護法應告知事項說明與聲明",
          href: "https://www.fundswap.com.tw/personal-protection/",
          // pathName: 'personal-protection'
        },
        {
          title: "隱私權保護政策",
          href: "https://www.fundswap.com.tw/privacy-policy/",
          // pathName: 'privacy-policy'
        },
        {
          title: "資訊安全政策",
          href: "https://www.fundswap.com.tw/security-terms-and-conditions/",
          // pathName: 'security-terms-and-conditions'
        },
        {
          title: "金融消費爭議處理專區",
          href: "https://www.foi.org.tw/index.html",
        },
        // {
        //   title: '金融友善服務專區',
        //   pathName: 'friendly-service'
        // },
        {
          title: "防制洗錢及打擊資助恐怖主義專區",
          href: "http://money.twsa.org.tw/",
        },
        {
          title: "證券投資反詐騙專區",
          href: "http://info.csa.org.tw/index.html",
        },
        {
          title: "資料共享隱私權政策聲明",
          href: "https://www.fundswap.com.tw/data_sharing_policy/",
        },
      ];
    },
    footerMessagesSectionOne() {
      let msg = this.footerMessages && this.footerMessages.slice(0, 2);
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0"); // 月份從 0 開始，所以需要 +1
      const day = String(now.getDate()).padStart(2, "0");

      if (msg) {
        msg = msg.map((message) =>
          message.replace("YYYY年MM月DD日", `${year}年${month}月${day}日`)
        );
      }
      return msg;
    },
    footerMessagesSectionTwo() {
      return (
        this.footerMessages &&
        this.footerMessages.slice(2, this.footerMessages.length)
      );
    },
    isMobile() {
      return require("@/assets/images/logo_h_ec_white.svg");
    },
  },

  mounted() {
    const apiUrl =
      process.env.NODE_ENV === "development"
        ? `https://dev.fundswap.com.tw${this.apiBaseUrl}`
        : this.apiBaseUrl;
    fetch(`${apiUrl}/content/page-main-info`, {
      credentials: "include",
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.footerMessages =
          data.data["experiment_page"] &&
          data.data["experiment_page"]["content-list"];
      });
  },

  methods: {
    openSectionTwo() {
      this.showSectionTwo = !this.showSectionTwo;
    },
    async handleOpenLinkAlert(info) {
      if (
        info.iconClass.includes("facebook") ||
        info.iconClass.includes("line")
      ) {
        // alert('即將導至外部網頁')
        const confirmed = await this.$refs.alertOutsideLink.show();

        if (!confirmed) {
          return;
        }
      }
      window.open(info.href, info.target).opener = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@use "tailwindcss/base" as base;
@use "tailwindcss/components" as components;
@use "tailwindcss/utilities" as utilities;

:root {
  --condition: #{isFundswapTrade};
}

@if not var(--condition) {
  base components utilities * {
    box-sizing: border-box;
    border-width: 0;
    border-style: solid;
    border-color: #f5f5f5;
  }
}
</style>
